import { ParentalLock } from '../../../../components/elements/ParentalLock';
import styles from '../styles/tvguide.module.sass';

export const EpgParentalLockOverlay = () => (
    <div className={styles.locked}>
        <ParentalLock />
    </div>
);
